export function toggleMaStatusUrl(url: string): string {
  const urlArray = url.split('/');
  const currentAction = urlArray[urlArray.length - 1];
  const nextAction = currentAction === 'pause' ? 'resume' : 'pause';
  urlArray[urlArray.length - 1] = nextAction;
  const newUrl = urlArray.join('/');

  return newUrl;
}
